/***********************/
/* Angular + external */
import { Component, ElementRef, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject, Subscription } from "rxjs";
/***********************/
/* BFX */
// models
import { BfxDialogData } from "./models/bfx-dialog-data.model";
// components
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
// services
import { LoggerService } from "@bfx/logger";
import { TradeDeal } from "shared/cubiq-services";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxBlotterTradeDialogActionEvent } from "../bfx-blotter-trade/services/bfx-trade-contextmenu.service";
import { BfxTradeDialogsProcessorService } from "./services/bfx-trade-dialogs-processor.service";
const logger = LoggerService.for(__dirname);

import { BfxConfigIDRefHelper } from "../../shared/helper-services/bfx-config-id-ref-helper";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: `bfx-dialog-trade-add-fill-comment`,
  templateUrl: `./html/bfx-dialog-trade-add-fill-comment.html`,
  standalone: false,
})
export class BfxDialogTradeAddFillCommentComponent
  extends BfxDialogBaseComponent
  implements OnDestroy
{
  /***************************************/
  /* DATA */
  public config: any = {
    debug: false,
  };

  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      title_template: "Add Fill Comment - Trade ",
      title_text: null,
      message_text: null,
      placeholder: "Fill Comment",
      event: null,
      comment: null, // model
      valid: false,
    },
  };

  private configurationSubscription: Subscription;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private _configService: BfxConfigService,
    private _translationService: TranslateService,
    private _tradeDialogProcessorService: BfxTradeDialogsProcessorService,
    private _element: ElementRef,
  ) {
    super();
    this.subscribeToConfiguration();
  }

  ngOnDestroy() {
    this.configurationSubscription.unsubscribe();
  }

  /**********************************************************************/
  /* INITIALIZATION */
  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config.debug = config.general.debug;
    });
  }

  /**********************************************************************/
  /* CANCEL TRADE CONFIRM - Open/Close Dialog */
  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      let event: BfxBlotterTradeDialogActionEvent = this.data.actionEvent;

      if (
        event !== null &&
        event !== undefined &&
        event.selectedTradeDeals &&
        event.selectedTradeDeals.length === 1
      ) {
        // title
        let title_text =
          this.data.dialogData.title_template +
          BfxConfigIDRefHelper.getDealRef(event.selectedItems[0]);
        // message text
        let message_text: string = "";
        if (event.selectedTradeDeals && event.selectedTradeDeals.length === 1) {
          let tradeDeal: TradeDeal = event.selectedTradeDeals[0];
          if (tradeDeal.fillComment != null && tradeDeal.fillComment.length > 0) {
            this.data.dialogData.comment = tradeDeal.fillComment;
          }
          message_text =
            tradeDeal.clientName +
            " " +
            tradeDeal.instrument +
            " " +
            (tradeDeal.dealDir ? "Buy" : "Sell") +
            " " +
            Number(tradeDeal.dealtAmt.toFixed(0)).toLocaleString() +
            " " +
            tradeDeal.dealtCcy +
            " @ " +
            tradeDeal.marketSpotStr;
        } else {
          logger.out.error(
            "ERROR: BfxDialogTradeAddFillCommentComponent.openTradeCancelConfirmDialog(): Invalid selectedItem at index 0, in event= ",
            event,
            " | TradeDeal instance expected!",
          );
        }
        // assign values and show the dialog
        NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this._element);
        this.assignValuesAndShowWarningDialog(title_text, message_text);
      } else {
        logger.out.error(
          "ERROR: BfxDialogTradeAddFillCommentComponent.openTradeCancelConfirmDialog(): Invalid event payload= ",
          event,
        );
      }
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxDialogTradeCancelComponent.openDialog(): Dialog exception! msg:",
        ex,
      );
    }
    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    super.closeDialog();

    this.data.dialogData.message_text = null;
    this.data.dialogData.comment = null;
    this.data.dialogData.title_text = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  /**********************************************************************/
  /* TRADE ADD FILL COMMENT - Actions */
  public actionAddFillComment_submit(): void {
    if (
      this.data.dialogData.comment &&
      this.data.dialogData.comment.length > 0 &&
      this.data.dialogData.comment.length < 251
    ) {
      this._tradeDialogProcessorService.executeAddFillComment(
        this.data.actionEvent,
        this.data.dialogData.comment,
      );
      this.closeDialog();
    } else {
      logger.out.warn(
        "WARNING: BfxDialogTradeAddFillCommentComponent.actionAddFillComment_submit(): Comment length out of bounds, comment= " +
          this.data.dialogData.comment,
      );
      this.data.dialogData.valid = false;
    }
  }

  public actionAddFillComment_cancel(): void {
    this.closeDialog();
  }

  /**********************************************************************/
  /*  TRADE ADD FILL COMMENT - Helpers */
  private assignValuesAndShowWarningDialog(title_text: string, message_text: string): void {
    // assign values
    this.data.dialogData.title_text = title_text;
    this.data.dialogData.message_text = message_text;
    // show the dialog
    this.data.dialogData.show = true;
  }
}
